import type { InsightConfigJsonField } from '../../../models/insightConfig.types'

export const CONFIG_FIELD_I18N_KEYS: Record<InsightConfigJsonField, string> = {
  detection_config: 'detectionConfig',
  detection_sources: 'detectionSources',
  eligibility_config: 'eligibilityConfig',
  template_variables: 'templateVariables',
  impact_formula: 'impactFormula',
  llm_config: 'llmConfig',
  column_definitions: 'columnDefinitions',
  hidden_dimensions: 'hiddenDimensions',
  tab_definitions: 'tabDefinitions',
  visualization_config: 'visualizationConfig',
}

export function configColumnI18nKey(field: string): string {
  return field.replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase())
}
